/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type SaveSamlProviderMutationVariables = Types.Exact<{
  input: Types.SsoProviderSamlUpsertInput;
}>;


export type SaveSamlProviderMutation = { __typename: 'Mutation', ssoProviderSamlUpsert: { __typename: 'SamlProvider', displayName?: string | null, validationStatus?: Types.SsoValidationStatus | null, strategy: Types.SsoProviderStrategy, options: { __typename: 'SamlOptions', entityId?: string | null, signInEndpoint?: string | null, signingCert?: string | null } } };

export type PublishSamlMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type PublishSamlMutation = { __typename: 'Mutation', ssoProviderSamlPublish: { __typename: 'Sso', id: string, domain: string, verificationStatus: Types.DomainVerificationStatus, provider?: { __typename: 'OidcProvider' } | { __typename: 'SamlProvider', displayName?: string | null, validationStatus?: Types.SsoValidationStatus | null, strategy: Types.SsoProviderStrategy } | null } };


export const SaveSamlProviderDocument = gql`
    mutation SaveSamlProvider($input: SsoProviderSamlUpsertInput!) {
  ssoProviderSamlUpsert(input: $input) {
    displayName
    validationStatus
    strategy
    options {
      entityId
      signInEndpoint
      signingCert
    }
  }
}
    `;
export type SaveSamlProviderMutationFn = ApolloReactCommon.MutationFunction<SaveSamlProviderMutation, SaveSamlProviderMutationVariables>;

/**
 * __useSaveSamlProviderMutation__
 *
 * To run a mutation, you first call `useSaveSamlProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSamlProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSamlProviderMutation, { data, loading, error }] = useSaveSamlProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSamlProviderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveSamlProviderMutation, SaveSamlProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveSamlProviderMutation, SaveSamlProviderMutationVariables>(SaveSamlProviderDocument, options);
      }
export type SaveSamlProviderMutationHookResult = ReturnType<typeof useSaveSamlProviderMutation>;
export type SaveSamlProviderMutationResult = ApolloReactCommon.MutationResult<SaveSamlProviderMutation>;
export type SaveSamlProviderMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveSamlProviderMutation, SaveSamlProviderMutationVariables>;
export const PublishSamlDocument = gql`
    mutation PublishSaml($id: ID!) {
  ssoProviderSamlPublish(input: {id: $id}) {
    id
    domain
    verificationStatus
    provider {
      ... on SamlProvider {
        displayName
        validationStatus
        strategy
      }
    }
  }
}
    `;
export type PublishSamlMutationFn = ApolloReactCommon.MutationFunction<PublishSamlMutation, PublishSamlMutationVariables>;

/**
 * __usePublishSamlMutation__
 *
 * To run a mutation, you first call `usePublishSamlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishSamlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishSamlMutation, { data, loading, error }] = usePublishSamlMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishSamlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PublishSamlMutation, PublishSamlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PublishSamlMutation, PublishSamlMutationVariables>(PublishSamlDocument, options);
      }
export type PublishSamlMutationHookResult = ReturnType<typeof usePublishSamlMutation>;
export type PublishSamlMutationResult = ApolloReactCommon.MutationResult<PublishSamlMutation>;
export type PublishSamlMutationOptions = ApolloReactCommon.BaseMutationOptions<PublishSamlMutation, PublishSamlMutationVariables>;